/**
 * <tm-geolocation-banner hidden data-flags='{"OM":"https://.../om.svg", ...}'>
 *   <img data-flag hidden>
 *   <p data-text></p>
 *   <button type="button" data-switch></button>
 *   <button type="button" data-dismiss></button>
 * </tm-geolocation-banner>
 *
 * On first paint, asks Shopify's own browsing_context_suggestions.json
 * (https://shopify.dev/docs/storefronts/themes/markets/localization-discovery)
 * whether the visitor's browser/IP suggests a better-matching country than
 * the one currently active, and if so shows a small dismissible banner
 * offering to switch -- never switches on its own. Shopify explicitly
 * recommends against a silent automatic switch (unreliable for VPNs and
 * search bots, breaks page caching), so this always waits for the visitor
 * to click "Switch" themselves.
 *
 * Skipped entirely once the visitor has dismissed or accepted a
 * suggestion -- localStorage.tm-geo-banner-seen, set either way, and
 * naturally also true after a switch (next load, the detected country
 * matches the now-current one, so nothing is suggested anyway).
 */
if (!customElements.get('tm-geolocation-banner')) {
  class TmGeolocationBanner extends HTMLElement {
    connectedCallback() {
      if (localStorage.getItem('tm-geo-banner-seen')) return;
      if (!window.Shopify?.routes?.root || !window.Shopify.country) return;

      this.flagEl = this.querySelector('[data-flag]');
      this.textEl = this.querySelector('[data-text]');
      this.switchButton = this.querySelector('[data-switch]');
      this.dismissButton = this.querySelector('[data-dismiss]');
      if (!this.textEl || !this.switchButton || !this.dismissButton) return;

      this.dismissButton.addEventListener('click', () => this.dismiss());

      this.suggest().catch(() => {});
    }

    async suggest() {
      const response = await fetch(
        `${window.Shopify.routes.root}browsing_context_suggestions.json` +
          `?country[enabled]=true&country[exclude]=${window.Shopify.country}`
      );
      if (!response.ok) return;

      const data = await response.json();
      const country = data?.detected_values?.country;
      if (!country || country.handle === window.Shopify.country) return;

      const textTemplate = this.dataset.textTemplate || '{country}';
      this.textEl.textContent = textTemplate.replace('{country}', country.name);

      const switchTemplate = this.dataset.switchTemplate || 'Switch to {country}';
      this.switchButton.textContent = switchTemplate.replace('{country}', country.name);
      this.switchButton.addEventListener('click', () => this.switchCountry(country.handle));

      if (this.flagEl) {
        let flags = {};
        try {
          flags = JSON.parse(this.dataset.flags || '{}');
        } catch {
          flags = {};
        }
        const flagUrl = flags[country.handle];
        if (flagUrl) {
          this.flagEl.src = flagUrl;
          this.flagEl.removeAttribute('hidden');
        }
      }

      this.removeAttribute('hidden');
    }

    switchCountry(countryHandle) {
      localStorage.setItem('tm-geo-banner-seen', '1');

      const form = document.createElement('form');
      form.action = '/localization';
      form.method = 'POST';
      form.hidden = true;

      const methodInput = document.createElement('input');
      methodInput.name = '_method';
      methodInput.value = 'PUT';
      form.append(methodInput);

      const countryInput = document.createElement('input');
      countryInput.name = 'country_code';
      countryInput.value = countryHandle;
      form.append(countryInput);

      const languageInput = document.createElement('input');
      languageInput.name = 'language_code';
      languageInput.value = window.Shopify.locale || window.Shopify.language || '';
      form.append(languageInput);

      document.body.append(form);
      form.submit();
    }

    dismiss() {
      localStorage.setItem('tm-geo-banner-seen', '1');
      this.setAttribute('hidden', '');
    }
  }

  customElements.define('tm-geolocation-banner', TmGeolocationBanner);
}
